import { Categories } from "../Categories";
import { Container } from "../Container";

export const DesktopCategories = () => (
  <Container sx={{ padding: "0 14px" }} direction="row" alignItems="center">
    <Categories />
  </Container>
);
